import { z } from 'zod';
export const projectDeleteSchema = z.object({
    confirmSlug: z.string().min(2).max(64),
});
//# sourceMappingURL=projectDelete.js.map